import React from 'react';
import PropTypes from 'prop-types';

const defaultProps = {
  color: 'black',
  width: '5em',
  height: '5em',
};

const iconPropTypes = {
  color: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
};

export const IconAgile = ({ color, ...props }) => (
  <svg
    id="icons_attributes_15_05_2019_Agile_svg__icons"
    viewBox="0 0 240 240"
    {...props}
  >
    <defs>
      <style>
        {
          `
          .icons_attributes_15_05_2019_Agile_svg__cls-1,
          .icons_attributes_15_05_2019_Agile_svg__cls-2,
          .icons_attributes_15_05_2019_Agile_svg__cls-3 {
            fill:none;
            stroke: ${color};
            stroke-miterlimit:10;
          }
          .icons_attributes_15_05_2019_Agile_svg__cls-1 {
            stroke-width:4px;
          }
          .icons_attributes_15_05_2019_Agile_svg__cls-2 {
            stroke-width:2px;
          }
          .icons_attributes_15_05_2019_Agile_svg__cls-3{
            stroke-width:2.43px;
          }
          .icons_attributes_15_05_2019_Agile_svg__cls-4{
            fill: ${color};
          }
          `
        }
      </style>
    </defs>
    <path
      className="icons_attributes_15_05_2019_Agile_svg__cls-1"
      d="M21.28 183.61c1.29-4.59 5.6-9.28 18.21-9.91l10.72-.84c3.62.07 30-43 30-43s11.65-17.18 28-15c30 4 37.91-18.92 37.91-31.39 0-15.11 11.59-16.25 19.21-8.6"
    />
    <path
      className="icons_attributes_15_05_2019_Agile_svg__cls-2"
      d="M189.23 98.81L97 191a5.31 5.31 0 01-3.91 1.56H21.32c-.05-1.23-1.13-5.05 0-8.94"
    />
    <path
      className="icons_attributes_15_05_2019_Agile_svg__cls-1"
      d="M120.21 208.86H220.5M70.21 144.86l15 7M61.21 157.86l15 7M149.21 73.86l-41-46M99.21 116.86c-1-5 7-11-16-36a641.59 641.59 0 00-51-49"
    />
    <circle
      className="icons_attributes_15_05_2019_Agile_svg__cls-2"
      cx={76.21}
      cy={164.86}
      r={5}
    />
    <circle
      className="icons_attributes_15_05_2019_Agile_svg__cls-2"
      cx={84.21}
      cy={151.86}
      r={5}
    />
    <path
      className="icons_attributes_15_05_2019_Agile_svg__cls-1"
      d="M78.21 131.86l15 7"
    />
    <circle
      className="icons_attributes_15_05_2019_Agile_svg__cls-2"
      cx={92.21}
      cy={138.86}
      r={5}
    />
    <path
      className="icons_attributes_15_05_2019_Agile_svg__cls-3"
      d="M151.5 55h48M208.5 55h15M104.5 40h48M161.5 40h15"
    />
    <path
      className="icons_attributes_15_05_2019_Agile_svg__cls-4"
      d="M170.25 94.61l-5.62 2.49a5.39 5.39 0 00-1.46-2.65 6.93 6.93 0 00-3.17-1.86l-6.2-1.91a13.36 13.36 0 01-3.44-1.59 11.18 11.18 0 01-2.62-2.36 10.75 10.75 0 01-1.7-3 9.46 9.46 0 01-.61-3.37 12.36 12.36 0 011-5.25 11.11 11.11 0 016.6-6 13.69 13.69 0 014.45-.74 13.92 13.92 0 014.27.69 11.56 11.56 0 013.9 2.15 12.87 12.87 0 013 3.71 14.53 14.53 0 011.62 5.33l-5.51.69a10.21 10.21 0 00-1-3.15 7 7 0 00-1.7-2.2 7.09 7.09 0 00-2.2-1.27 7.3 7.3 0 00-2.46-.42 6.92 6.92 0 00-2.25.37 5.23 5.23 0 00-1.91 1.14 5.63 5.63 0 00-1.32 2 7.25 7.25 0 00-.5 2.84 4.41 4.41 0 001.17 2.94 6.42 6.42 0 003.07 1.93l6.68 2.07a12.19 12.19 0 015.13 2.81 10.1 10.1 0 012.78 4.61zM170.39 105.52a3.77 3.77 0 01-1.14 2.77 3.71 3.71 0 01-2.72 1.14 3.88 3.88 0 01-3.91-3.91 3.71 3.71 0 011.13-2.72 3.77 3.77 0 012.77-1.13 3.88 3.88 0 013.85 3.85z"
    />
    <path
      className="icons_attributes_15_05_2019_Agile_svg__cls-1"
      d="M104.44 196.64a16.28 16.28 0 01-11.56 4.79H21.25s-1 10.71 6.51 10.71h65.35a27.22 27.22 0 0018.56-7.52l84.92-85a10 10 0 00.23-15.34l-92.34 92.34z"
    />
  </svg>
);

IconAgile.defaultProps = { ...defaultProps };
IconAgile.propTypes = { ...iconPropTypes };

export const IconAnalytical = ({ color, ...props }) => (
  <svg
    id="icons_attributes_15_05_2019_Analytical_svg__icons"
    viewBox="0 0 240 240"
    {...props}
  >
    <defs>
      <style>
        {
          `
          .icons_attributes_15_05_2019_Analytical_svg__cls-1 {
            fill: ${color};
          }
          .icons_attributes_15_05_2019_Analytical_svg__cls-2,
          .icons_attributes_15_05_2019_Analytical_svg__cls-3 {
            fill: none;
            stroke: ${color};
            stroke-miterlimit: 10;
          }
          .icons_attributes_15_05_2019_Analytical_svg__cls-2 {
            stroke-width: 4px;
          }
          .icons_attributes_15_05_2019_Analytical_svg__cls-3 {
            stroke-width: 2px;
          }`
        }
      </style>
    </defs>
    <path
      className="icons_attributes_15_05_2019_Analytical_svg__cls-1"
      d="M60.38 188.28l-5.8 2.1a5.28 5.28 0 00-1.29-2.7 7 7 0 00-3.1-2l-6.11-2.27a13.53 13.53 0 01-3.36-1.78 11.14 11.14 0 01-2.48-2.49 10.53 10.53 0 01-1.51-3 9.16 9.16 0 01-.4-3.35 12 12 0 011.38-5.1 11.2 11.2 0 013-3.51 11.37 11.37 0 014-2 14.05 14.05 0 014.52-.45 14.25 14.25 0 014.24.95 11.67 11.67 0 013.78 2.32 12.71 12.71 0 012.75 3.83 14.11 14.11 0 011.28 5.35l-5.58.33a9.91 9.91 0 00-.76-3.17 6.88 6.88 0 00-1.56-2.27 7.15 7.15 0 00-2.13-1.39 7.47 7.47 0 00-2.45-.57 7.1 7.1 0 00-2.29.22 5.31 5.31 0 00-2 1 5.57 5.57 0 00-1.46 1.85 7 7 0 00-.69 2.76 4.3 4.3 0 001 3 6.46 6.46 0 003 2.1l6.58 2.46a12.3 12.3 0 015 3.14 9.9 9.9 0 012.44 4.64zM59.83 199a3.7 3.7 0 01-1.32 2.66 3.78 3.78 0 01-2.8.95 3.83 3.83 0 01-2.71-1.26 3.79 3.79 0 01.35-5.41 3.85 3.85 0 012.85-.94 3.76 3.76 0 012.66 1.29 3.62 3.62 0 01.97 2.71z"
    />
    <circle
      className="icons_attributes_15_05_2019_Analytical_svg__cls-2"
      cx={51}
      cy={45.5}
      r={12}
    />
    <circle
      className="icons_attributes_15_05_2019_Analytical_svg__cls-2"
      cx={191}
      cy={45.5}
      r={12}
    />
    <circle
      className="icons_attributes_15_05_2019_Analytical_svg__cls-2"
      cx={121}
      cy={45.5}
      r={12}
    />
    <circle
      className="icons_attributes_15_05_2019_Analytical_svg__cls-2"
      cx={51}
      cy={116.5}
      r={12}
    />
    <circle
      className="icons_attributes_15_05_2019_Analytical_svg__cls-2"
      cx={191}
      cy={116.5}
      r={12}
    />
    <circle
      className="icons_attributes_15_05_2019_Analytical_svg__cls-2"
      cx={121}
      cy={116.5}
      r={12}
    />
    <circle
      className="icons_attributes_15_05_2019_Analytical_svg__cls-2"
      cx={121}
      cy={187.5}
      r={12}
    />
    <path
      className="icons_attributes_15_05_2019_Analytical_svg__cls-3"
      d="M114 177.5l-56-53M51 103.5v-47M129 110.5l52-56M191 58.5v48M121 57.5v48M191 127.5v46M109 44.5H64"
    />
    <circle
      className="icons_attributes_15_05_2019_Analytical_svg__cls-2"
      cx={191}
      cy={187.5}
      r={12}
    />
  </svg>
);

IconAnalytical.defaultProps = { ...defaultProps };
IconAnalytical.propTypes = { ...iconPropTypes };

export const IconComposed = ({ color, ...props }) => (
  <svg
    id="icons_attributes_15_05_2019_Composed_svg__icons"
    viewBox="0 0 240 240"
    {...props}
  >
    <defs>
      <style>
        {
          `
          .icons_attributes_15_05_2019_Composed_svg__cls-1 {
            fill: ${color};
          }
          .icons_attributes_15_05_2019_Composed_svg__cls-2,
          .icons_attributes_15_05_2019_Composed_svg__cls-3,
          .icons_attributes_15_05_2019_Composed_svg__cls-4 {
            fill: none;
            stroke: ${color};
            stroke-miterlimit: 10;
          }
          .icons_attributes_15_05_2019_Composed_svg__cls-2{
            stroke-width: 4px;
          }
          .icons_attributes_15_05_2019_Composed_svg__cls-4{
            stroke-width: 2px;
          }`
        }
      </style>
    </defs>
    <path
      className="icons_attributes_15_05_2019_Composed_svg__cls-1"
      d="M123.79 54.18l-5.62 2.49a5.39 5.39 0 00-1.46-2.67 6.93 6.93 0 00-3.21-1.85l-6.2-1.91a13.36 13.36 0 01-3.44-1.59 11.18 11.18 0 01-2.62-2.36 10.75 10.75 0 01-1.7-3 9.45 9.45 0 01-.61-3.29 12.35 12.35 0 011-5.25 11.11 11.11 0 016.6-6A13.7 13.7 0 01111 28a13.92 13.92 0 014.27.69 11.56 11.56 0 013.9 2.15 12.87 12.87 0 013 3.71 14.52 14.52 0 011.62 5.33l-5.51.69a10.2 10.2 0 00-1-3.15 7 7 0 00-1.7-2.2 7.09 7.09 0 00-2.2-1.27 7.3 7.3 0 00-2.46-.42 6.92 6.92 0 00-2.25.37 5.23 5.23 0 00-1.87 1.1 5.63 5.63 0 00-1.32 2 7.25 7.25 0 00-.5 2.84 4.41 4.41 0 001.17 2.94 6.42 6.42 0 003.07 1.93l6.68 2.07a12.19 12.19 0 015.1 2.84 10.1 10.1 0 012.79 4.56zM123.93 65.09a3.77 3.77 0 01-1.14 2.77 3.71 3.71 0 01-2.71 1.14 3.88 3.88 0 01-3.91-3.91 3.71 3.71 0 011.13-2.72 3.78 3.78 0 012.77-1.13 3.88 3.88 0 013.85 3.85z"
    />
    <path
      className="icons_attributes_15_05_2019_Composed_svg__cls-2"
      d="M117.47 93v107M146 216H88.93M129.97 207h-25M37.5 89.5s11 6 13 6 68-16 68-16l71 17 11-7M78 141a28 28 0 01-56 0"
    />
    <path
      className="icons_attributes_15_05_2019_Composed_svg__cls-3"
      d="M77 142L51 94M24 142l26-48M50 95v76"
    />
    <path
      className="icons_attributes_15_05_2019_Composed_svg__cls-4"
      d="M64 142H24"
    />
    <path
      className="icons_attributes_15_05_2019_Composed_svg__cls-2"
      d="M215 144a28 28 0 01-56 0"
    />
    <path
      className="icons_attributes_15_05_2019_Composed_svg__cls-3"
      d="M214 145l-26-48M161 145l26-48M187 98v76"
    />
    <path
      className="icons_attributes_15_05_2019_Composed_svg__cls-4"
      d="M201 145h-40"
    />
  </svg>
);

IconComposed.defaultProps = { ...defaultProps };
IconComposed.propTypes = { ...iconPropTypes };

export const IconCourageous = ({ color, ...props }) => (
  <svg
    id="icons_attributes_15_05_2019_Courageous_svg__icons"
    viewBox="0 0 240 240"
    {...props}
  >
    <defs>
      <style>
        {
          `
          .icons_attributes_15_05_2019_Courageous_svg__cls-2,
          .icons_attributes_15_05_2019_Courageous_svg__cls-5 {
            fill: none;
            stroke: ${color};
            stroke-miterlimit:10;
          }
          .icons_attributes_15_05_2019_Courageous_svg__cls-2 {
            stroke-width: 1.64px;
          }
          .icons_attributes_15_05_2019_Courageous_svg__cls-3 {
            fill: ${color};
          }
          .icons_attributes_15_05_2019_Courageous_svg__cls-5 {
            stroke-width: 4px;
          }`
        }
      </style>
    </defs>
    <path
      d="M132.69 89.72a12.79 12.79 0 11-25.58 0"
      strokeWidth={3}
      fill="none"
      stroke={color}
      strokeMiterlimit={10}
    />
    <path
      className="icons_attributes_15_05_2019_Courageous_svg__cls-2"
      d="M126.51 105.36a2.87 2.87 0 00-2.87-2.87h-8.32a2.87 2.87 0 00-2.87 2.87 1.58 1.58 0 01-1.58 1.58h-1.47a2.17 2.17 0 002.17 2.17h15.82a2.17 2.17 0 002.17-2.17h-1.47a1.58 1.58 0 01-1.58-1.58zM112.45 217.81a2.87 2.87 0 002.87 2.87h8.32a2.87 2.87 0 002.87-2.87 1.58 1.58 0 011.58-1.58h1.47a2.17 2.17 0 00-2.17-2.17h-15.82a2.17 2.17 0 00-2.17 2.17h1.47a1.58 1.58 0 011.58 1.58z"
    />
    <path
      className="icons_attributes_15_05_2019_Courageous_svg__cls-3"
      d="M129.69 109.1a.83.83 0 01.83.83 1.23 1.23 0 01-.93 1.19v40.35h32.1a1.23 1.23 0 011.19-.93.83.83 0 01.83.83v20.41a.83.83 0 01-.83.83 1.23 1.23 0 01-1.19-.93h-32.1v40.38a1.23 1.23 0 01.93 1.19.83.83 0 01-.83.83h-20.41a.83.83 0 01-.83-.83 1.23 1.23 0 01.93-1.19v-40.37H77.25a1.23 1.23 0 01-1.19.93.83.83 0 01-.83-.83v-20.41a.83.83 0 01.83-.83 1.23 1.23 0 011.19.93h32.13v-40.35a1.23 1.23 0 01-.93-1.19.83.83 0 01.83-.83h20.41m0-4h-20.41a4.84 4.84 0 00-4.83 4.83 5.22 5.22 0 00.93 3v34.57H79a5.22 5.22 0 00-3-.93 4.84 4.84 0 00-4.83 4.83v20.41a4.84 4.84 0 004.83 4.83 5.22 5.22 0 003-.93h26.34v34.59a5.22 5.22 0 00-.93 3 4.84 4.84 0 004.83 4.83h20.41a4.84 4.84 0 004.83-4.83 5.22 5.22 0 00-.93-3v-34.62h26.35a5.22 5.22 0 003 .93 4.84 4.84 0 004.83-4.83v-20.41a4.84 4.84 0 00-4.83-4.83 5.22 5.22 0 00-3 .93h-26.31v-34.57a5.22 5.22 0 00.93-3 4.84 4.84 0 00-4.83-4.83z"
    />
    <path
      strokeWidth={2}
      fill="none"
      stroke={color}
      strokeMiterlimit={10}
      d="M159.59 155.6h-34.13v-42.37H113.5v42.37H79.35v11.97h34.15v42.4h11.96v-42.4h34.13V155.6z"
    />
    <path
      className="icons_attributes_15_05_2019_Courageous_svg__cls-2"
      d="M165.88 170.19v1.47a2.17 2.17 0 01-2.17-2.17v-15.81a2.17 2.17 0 012.17-2.17V153a1.58 1.58 0 001.58 1.58 2.87 2.87 0 012.87 2.87v8.32a2.87 2.87 0 01-2.87 2.87 1.58 1.58 0 00-1.58 1.55zM71.5 154.55a2.87 2.87 0 00-2.87 2.87v8.32a2.87 2.87 0 002.87 2.87 1.58 1.58 0 011.58 1.58v1.47a2.17 2.17 0 002.17-2.17v-15.81a2.17 2.17 0 00-2.17-2.17V153a1.58 1.58 0 01-1.58 1.55zM170.33 158.28a3.31 3.31 0 110 6.62M68.63 158.28a3.31 3.31 0 000 6.62"
    />
    <path
      className="icons_attributes_15_05_2019_Courageous_svg__cls-2"
      d="M165.88 152.23v-.73a2.17 2.17 0 00-2.17 2.17v.73a2.17 2.17 0 012.17-2.17zM73.08 151.5v.73a2.17 2.17 0 012.17 2.17v-.73a2.17 2.17 0 00-2.17-2.17zM122.79 220.68a3.31 3.31 0 01-6.62 0"
    />
    <path
      className="icons_attributes_15_05_2019_Courageous_svg__cls-3"
      d="M124.6 113.35h-9.85l5.11 4.37 4.74-4.37zM114.73 209.54l9.85.1-5.06-4.43-4.79 4.33zM80.13 156.54v9.85l4.38-5.1-4.38-4.75zM158.87 165.57v-9.85l-4.37 5.11 4.37 4.74zM132.23 56.61l-5.62 2.49a5.39 5.39 0 00-1.46-2.65 6.93 6.93 0 00-3.21-1.85l-6.2-1.91a13.36 13.36 0 01-3.44-1.59 11.18 11.18 0 01-2.62-2.36 10.75 10.75 0 01-1.7-3 9.46 9.46 0 01-.61-3.37 12.36 12.36 0 011-5.25 11.11 11.11 0 016.6-6 13.69 13.69 0 014.45-.74 13.92 13.92 0 014.27.69 11.56 11.56 0 013.9 2.15 12.87 12.87 0 013 3.71 14.53 14.53 0 011.62 5.33l-5.51.69a10.21 10.21 0 00-1-3.15 7 7 0 00-1.7-2.2 7.09 7.09 0 00-2.2-1.27 7.3 7.3 0 00-2.46-.42 6.92 6.92 0 00-2.25.37 5.23 5.23 0 00-1.91 1.14 5.63 5.63 0 00-1.32 2 7.25 7.25 0 00-.5 2.84 4.41 4.41 0 001.17 2.94 6.42 6.42 0 003.07 1.93l6.68 2.07a12.19 12.19 0 015.17 2.8 10.1 10.1 0 012.78 4.61zM132.37 67.52a3.77 3.77 0 01-1.14 2.77 3.71 3.71 0 01-2.72 1.14 3.88 3.88 0 01-3.91-3.91 3.71 3.71 0 011.13-2.72 3.77 3.77 0 012.77-1.13 3.88 3.88 0 013.85 3.85z"
    />
    <path
      className="icons_attributes_15_05_2019_Courageous_svg__cls-5"
      d="M93.5 81.16V14.01M159.5 61.17v9.14a5.63 5.63 0 01-2.63 4.76L125.5 94.83a9.93 9.93 0 01-10.59 0L83.54 75.07a5.63 5.63 0 01-2.63-4.76V34.67M159.5 49.5v.33M80.92 23.67v-9.66h78.58V49.5M145.5 82.16V15.01"
    />
  </svg>
);

IconCourageous.defaultProps = { ...defaultProps };
IconCourageous.propTypes = { ...iconPropTypes };

export const IconDetermined = ({ color, ...props }) => (
  <svg
    id="icons_attributes_15_05_2019_Determined_svg__icons"
    viewBox="0 0 240 240"
    {...props}
  >
    <defs>
      <style>
        {
          `
          .icons_attributes_15_05_2019_Determined_svg__cls-1{
            fill: ${color};
          }
          .icons_attributes_15_05_2019_Determined_svg__cls-2,
          .icons_attributes_15_05_2019_Determined_svg__cls-3 {
            fill: none;
            stroke: ${color};
            stroke-miterlimit: 10;
          }
          .icons_attributes_15_05_2019_Determined_svg__cls-2 {
            stroke-width: 4px;
          }
          .icons_attributes_15_05_2019_Determined_svg__cls-3 {
            stroke-width: 2px;
          }`
        }
      </style>
    </defs>
    <path
      className="icons_attributes_15_05_2019_Determined_svg__cls-1"
      d="M152.32 32.59l-2.43-.35A2.16 2.16 0 00150 31a2.77 2.77 0 00-.69-1.31l-1.69-2a5.34 5.34 0 01-.83-1.27 4.47 4.47 0 01-.39-1.36 4.3 4.3 0 01.06-1.37 3.78 3.78 0 01.51-1.27 4.94 4.94 0 011.47-1.56 4.44 4.44 0 013.51-.62 5.48 5.48 0 011.67.7 5.57 5.57 0 011.3 1.14 4.62 4.62 0 01.86 1.56 5.15 5.15 0 01.22 1.96 5.81 5.81 0 01-.59 2.15l-2-.94a4.08 4.08 0 00.35-1.27 2.79 2.79 0 00-.11-1.11 2.84 2.84 0 00-.47-.9 2.92 2.92 0 00-.74-.67 2.77 2.77 0 00-.84-.35 2.09 2.09 0 00-.89 0 2.25 2.25 0 00-.87.38 2.9 2.9 0 00-.77.85 1.76 1.76 0 00-.23 1.24 2.57 2.57 0 00.63 1.31l1.82 2.12a4.88 4.88 0 011.12 2.06 4 4 0 01-.09 2.12zM150 36.32a1.51 1.51 0 01-1 .7 1.48 1.48 0 01-1.16-.19 1.55 1.55 0 01-.49-2.16 1.49 1.49 0 011-.68 1.51 1.51 0 011.18.21 1.55 1.55 0 01.48 2.13z"
    />
    <path
      className="icons_attributes_15_05_2019_Determined_svg__cls-2"
      d="M16 241l.55-3.42s12.56-17 14.32-19 11.8-19.48 13.31-21.43 4.27-11.69 5-13.88 3.27-8.52 5.78-8.77 4-.73 4.52-1.95 6.28-13.4 7.79-15.34a46.29 46.29 0 015.53-6.33c1.76-1.46 4.77-2.68 7.28-1.22s7.28 2.92 12.31 3.65 11.05 1 11.05 1 16.78 3.29 20.54 5.48M171.43 176.4c2.76 0 23.69 3.7 23.94 2.72s8.54 14.61 13.31 15.1 9.8 10 9.8 10L233 241"
    />
    <path
      className="icons_attributes_15_05_2019_Determined_svg__cls-1"
      d="M138.34 13.49c12.33 4 24.65-.16 37 8.86-3.25 6.51-6.5 13.94-9.76 21.9-12-3.34-24 .48-36-8.31 2.92-6.83 5.84-14.41 8.76-22.45M136 8.32q-.72 1.92-1.44 3.79c-2.92 7.59-5.84 14.6-8.76 20.74q-.69 1.44-1.37 2.82a38.73 38.73 0 003.65 3.43c12 9.85 24 6.29 36 9.08a33.26 33.26 0 013.61 1.05q.77-1.82 1.53-3.59a218.06 218.06 0 019.78-20.1q.81-1.43 1.61-2.77a39.1 39.1 0 00-3.78-3.57c-12.33-10.13-24.65-6.17-37-9.58a31.86 31.86 0 01-3.83-1.3z"
    />
    <path
      className="icons_attributes_15_05_2019_Determined_svg__cls-3"
      d="M176 96.48c-.51 2-.91-2.12 2.56-4.48 2.85-1.94 6.4-3.2 9.6-4.48s7-2.56 10.24-5.76a57.63 57.63 0 006.4-7.68c1.92-2.56 2.56-3.84 1.92-4.48s-1.92-3.2-3.2-3.84-1.92-1.92-3.2 0-4.48 5.12-6.4 5.76a89.08 89.08 0 00-8.32 3.84c-2.56 1.28-3.84 1.28-6.4 1.92s-3.2.64-3.84 1.28S174 90 176 96.48zM148.48 79.2s-.64-3.84-3.2-4.48-4.48-.64-7.68-2.56-4.48-1.92-5.76-3.84-3.84-3.84-5.12-5.12-3.84-2.56-4.48-3.2-2.56 0-3.2 1.28-1.28 1.28-1.92 2.56 0 1.28.64 2.56a16.06 16.06 0 003.2 5.12A23.91 23.91 0 01124.8 76c1.28 1.92 1.92 3.84 4.48 5.12S131.84 82.4 135 85s5.76 1.92 6.4 4.48a18 18 0 01.64 3.2 11 11 0 011.28-5.12c1.28-1.92 1.28-4.48 3.2-5.76s1.96-2.6 1.96-2.6z"
    />
    <path
      className="icons_attributes_15_05_2019_Determined_svg__cls-3"
      d="M173.44 108A92.94 92.94 0 00176 95s-1.67-11-1.83-12 1.33-5.17 1.33-5.17S175 73 170 76M159 80c-1.92.64-.92 4.32-2.2 8.8s-1.92 10.24-2.56 17.28-1.24 12.16-1.24 14.08v1.92l1 .92a14 14 0 014.72.36c3.2.64 6.4 1.28 8.32 3.2s2.56 1.92 3.84 5.12 1.2-4.62 2.56-9.6"
    />
    <path
      className="icons_attributes_15_05_2019_Determined_svg__cls-3"
      d="M157 88c1-8 8.76-10.72 10.68-11.36l3.84-1.28M142.08 96.48v-3.84M153 123.36c-2.56.64-4.48 0-7.68-.64a26.51 26.51 0 00-6.4-.64c-1.92 0 0-4.48 1.28-5.76s-.64-3.2 0-3.84 1.28-.64 1.28-2.56.64-2.56.64-4.48M146 82s2.8-1.84 2-3.92 1.76-3.36 3.68-2.08 6.69 3 6.32 6"
    />
    <path
      className="icons_attributes_15_05_2019_Determined_svg__cls-3"
      d="M156.8 78.72a4.44 4.44 0 003.68 1c2.08-.48 4-2.4 5.28-5a5.63 5.63 0 00-.16-6A7.39 7.39 0 00158 65c-3.2.36-4.4 2.88-4.4 6.08 0 2.02.64 5.92 3.2 7.64zM137.6 121.76c-2.56.32-5.76 4.16-7.68 4.8s-5.12 3.2-5.76 5.12-1.28 3.2-1.28 4.48.64 3.2 1.92 3.2 1.28-.64 4.48-.64a26.41 26.41 0 015.76.64v-3.2a70.46 70.46 0 0111.52-3.84c5.76-1.28 7.68-3.2 7.68-3.2s2.26-1.35 1.28-5.12c-.52-2-.64 1-6.08-.48"
    />
    <path
      className="icons_attributes_15_05_2019_Determined_svg__cls-3"
      d="M154.88 128.48a49.8 49.8 0 001.92 5.76c1.28 3.2.64 5.76 1.28 7s1.28 6.4 1.28 7 .64 5.76 1.28 6.4 4.48-.64 7.68-1.92 3.2-.64 3.2-1.92-1.28-3.2-1.28-6.4 1-12 1-12-7.48-8.47-10.93-8.87c-5.31-.53-5.43 4.95-5.43 4.95z"
    />
    <path
      className="icons_attributes_15_05_2019_Determined_svg__cls-3"
      d="M171.52 150.88c3.23-2.44.64 14.08 0 15.36-.42.85-.85 5.62-1.27 9.13-.22 1.79 1 1.2.75 1.64-.64 1.28 1 5-2 6-1.36.45-1.32-.76-2 .52s-3.84 2.56-4.48 2.56A34 34 0 01156 185c-1.92-.64-2.36-1.72-3-3s1.24-3 2.52-3.6a8.85 8.85 0 004.48-4.48c1-1.92 2-3 2-4.92s-1.36-6-1.36-9.16.16-6.36.16-6.36 8.2-.73 10.72-2.6zM171.2 75.08c-2.89.35-.54-1.51.8-8.08 1.28-6.27-4.2-11.2-9-12s-10.4 1-12 5-2.73 12.33 1 15-.8-2.68 1.07-5.79S162 63 165 67c1.6 2.13.87 8.88.87 8.88zM124 41L96.96 96.49M136.48 167.44c-1 .55-2.08-1.2-3.36-1.2-2.56 0-11.52-2.56-14.08-2.56s-4.17-.79-3.2-2.56C117 159 117.8 159 121 159s4 0 6-1c.57-.29.36-4.56-.28-7.76s-3.52-9.6-3.36-11.2c0 0 12.64-2.37 12.64 1.3V155c0 1 3 5 3 7s2 2.87-2.52 5.44z"
    />
    <circle
      className="icons_attributes_15_05_2019_Determined_svg__cls-3"
      cx={65.5}
      cy={32.5}
      r={4}
    />
    <circle
      className="icons_attributes_15_05_2019_Determined_svg__cls-3"
      cx={22}
      cy={69}
      r={4}
    />
    <circle
      className="icons_attributes_15_05_2019_Determined_svg__cls-3"
      cx={62}
      cy={113}
      r={4}
    />
    <circle
      className="icons_attributes_15_05_2019_Determined_svg__cls-3"
      cx={206.5}
      cy={25.5}
      r={4}
    />
    <circle
      className="icons_attributes_15_05_2019_Determined_svg__cls-3"
      cx={217.5}
      cy={138.5}
      r={4}
    />
    <circle
      className="icons_attributes_15_05_2019_Determined_svg__cls-3"
      cx={23}
      cy={156}
      r={4}
    />
    <path
      className="icons_attributes_15_05_2019_Determined_svg__cls-2"
      d="M159.7 173.33c-17.09 12.64 4 10.7 7 9.72s3.33.72 4-1.94c2-7.78 23.12-1.94 23.12-1.94L215 198.62s-5 14.59-14.08 6.81c-10.08-8.67-9-5.83-14.08-4.86-21.1 4.08-16.09-5.83-28.15 5.83-11.77 11.38-11.57-10.6-28.15-1-5 2.92-6.2 16.37-28.15-4.86-13.07-12.64-21.73 6.29-30.16 12.64-8.91 6.71-21.69 16.64-27.15 2.92C40.18 203.78 28 222 28 222s18.1-22 19.1-32.41 4-13.29 7-15.23 11.1-13.67 12.1-17.56 8-7.78 13.07-6.81 24.8 2.92 31.5 5.83 9.72 2.92 9.72 2.92-8 0-5 2.92 15.08 1.94 17.09 3.89 4.36-.65 7.71.65 19.44 6.16 19.44 6.16a71.32 71.32 0 00-10.05-3.89c-10.05-2.92-11.06-3.89-11.06-3.89"
    />
    <path
      className="icons_attributes_15_05_2019_Determined_svg__cls-3"
      d="M161 110s3-1 5 0 8-2 8-2M142 107a10 10 0 014 1 7.74 7.74 0 003 1M202.88 64.8s0-1 1.92-2.88 2.56-1.28 3.84 0 2.56 3.2 1.92 3.84S209.92 69 208 69a15.29 15.29 0 00-2 0M120.8 59.52s.16-2.72-1.12-4-3.2-1.28-3.2 0-.64 1.28-1.28 1.92-1.92 2.56-1.28 3.2 3.84 1.92 3.84 2.56"
    />
  </svg>
);

IconDetermined.defaultProps = { ...defaultProps };
IconDetermined.propTypes = { ...iconPropTypes };

export const IconEmpathetic = ({ color, ...props }) => (
  <svg
    id="icons_attributes_15_05_2019_Empathetic_svg__icons"
    viewBox="0 0 240 240"
    {...props}
  >
    <defs>
      <style>
        {
          `
          .icons_attributes_15_05_2019_Empathetic_svg__cls-1 {
            fill: ${color};
          }`
        }
      </style>
    </defs>
    <path
      className="icons_attributes_15_05_2019_Empathetic_svg__cls-1"
      d="M151.53 73.47a15.09 15.09 0 00-9-8.13 18.59 18.59 0 00-6-1 18.9 18.9 0 00-5.79.93 15.7 15.7 0 00-5.29 2.91 16.27 16.27 0 00-2.54 2.71 16.27 16.27 0 00-2.54-2.71 15.7 15.7 0 00-5.29-2.91 18.9 18.9 0 00-5.79-.93 18.59 18.59 0 00-6 1 15.09 15.09 0 00-9 8.13 16.78 16.78 0 00-1.4 7.12 12.84 12.84 0 00.83 4.57 14.6 14.6 0 002.3 4 15.18 15.18 0 003.56 3.2 18.13 18.13 0 004.68 2.16l8.42 2.59a9.41 9.41 0 014.32 2.55 7.32 7.32 0 012 3.6h7.82a7.33 7.33 0 012-3.6 9.41 9.41 0 014.35-2.52l8.42-2.59a18.13 18.13 0 004.68-2.16 15.18 15.18 0 003.56-3.2 14.6 14.6 0 002.3-4 12.84 12.84 0 00.83-4.57 16.78 16.78 0 00-1.43-7.15zm-8.38 10.9A8.72 8.72 0 01139 87l-9.1 2.8a16.55 16.55 0 00-6.9 3.89l-.06.06-.06-.06a16.55 16.55 0 00-6.94-3.89l-9.11-2.8a8.72 8.72 0 01-4.17-2.63 6 6 0 01-1.58-4 9.85 9.85 0 01.68-3.85 7.64 7.64 0 011.8-2.66 7.11 7.11 0 012.59-1.55 9.4 9.4 0 013.06-.5 9.92 9.92 0 013.35.58 9.63 9.63 0 013 1.73 9.47 9.47 0 012.3 3 13.86 13.86 0 011.3 4.28l3.76-.47 3.76.47a13.86 13.86 0 011.32-4.3 9.47 9.47 0 012.3-3 9.63 9.63 0 013-1.73 9.92 9.92 0 013.35-.58 9.4 9.4 0 013.06.5 7.11 7.11 0 012.59 1.55 7.65 7.65 0 011.8 2.66 9.85 9.85 0 01.68 3.85 6 6 0 01-1.64 4.02z"
    />
    <circle
      className="icons_attributes_15_05_2019_Empathetic_svg__cls-1"
      cx={122.9}
      cy={112.5}
      r={4.49}
      transform="rotate(-27.77 122.923 112.503)"
    />
    <path
      d="M99.93 215s.69-27-10.65-34.24c-2.56-1.63-4-3.49-11.76-3.21s-15.48 1-18.69-.69-7.69-5.49-7.31-9.78 2-6.08-.2-8.67-4.27-6.15-2.67-7.93 2.25-2 2.25-2-2.91-1.46-3.7-3.45.8-9.07.84-9.54-.35-1.47-1.7-2.55-3.65-2.25-5-3.33-4.26-3.5.72-8.11c2.25-2.08 8.56-9.82 9.64-11.17s3.16-3.09 3.84-5.43 1-5.68 1-11-.34-16.19 3.41-26 10.6-16.29 18.56-21.53c4.88-3.22 16.11-8.2 27.77-9.57s23.07-3.09 38.46 0c16.22 3.28 25.24 11 32.59 23.07 7.81 12.87 9.43 23.16 8.68 37s-3.5 18.72-12.32 31.4-18.27 27.24-14.54 44.88"
      fill="none"
      stroke={color}
      strokeMiterlimit={10}
      strokeWidth={4}
    />
  </svg>
);

IconEmpathetic.defaultProps = { ...defaultProps };
IconEmpathetic.propTypes = { ...iconPropTypes };

export const IconHonest = ({ color, ...props }) => (
  <svg
    id="icons_attributes_15_05_2019_Honest_svg__icons"
    viewBox="0 0 240 240"
    {...props}
  >
    <defs>
      <style>
        {
          `
          .icons_attributes_15_05_2019_Honest_svg__cls-2 {
            fill: none;
            stroke: ${color};
            stroke-miterlimit: 10
          }
          .icons_attributes_15_05_2019_Honest_svg__cls-3 {
            fill: ${color}
          }`
        }
      </style>
    </defs>
    <path
      d="M211.95 120.39c0 9.82-11.31 17.73-14.19 26.58-3 9.18 1.42 22.21-4.14 29.85s-19.4 7.53-27.12 13.15-11.7 18.76-20.88 21.74c-8.86 2.88-19.86-5.33-29.67-5.33s-20.81 8.2-29.67 5.32C77.1 208.73 73 195.53 65.4 190s-21.5-5.43-27.12-13.15-1.16-20.7-4.15-29.85c-2.88-8.86-14.19-16.77-14.19-26.58s11.31-17.73 14.19-26.58c3-9.18-1.42-22.21 4.14-29.85s19.4-7.53 27.12-13.15S77.1 32 86.28 29.06c8.86-2.88 19.86 5.33 29.67 5.33s20.81-8.2 29.67-5.32c9.18 3 13.23 16.18 20.88 21.74S188 56.24 193.62 64s1.16 20.67 4.14 29.85c2.88 8.81 14.19 16.72 14.19 26.54z"
      strokeWidth={4}
      fill="none"
      stroke={color}
      strokeMiterlimit={10}
    />
    <path
      className="icons_attributes_15_05_2019_Honest_svg__cls-2"
      d="M198.95 120.39c0 8.41-11.09 15-13.55 22.57-2.56 7.87 2.47 19.68-2.3 26.23s-17.63 5.46-24.24 10.27-9.38 17.34-17.25 19.89c-7.59 2.47-17.24-6-25.65-6s-18.06 8.42-25.65 6c-7.87-2.56-10.7-15.13-17.25-19.89s-19.45-3.66-24.26-10.28.26-18.36-2.3-26.23c-2.5-7.59-13.55-14.15-13.55-22.56S44 105.42 46.5 97.82C49.06 90 44 78.15 48.8 71.6S66.43 66.14 73 61.32 82.43 44 90.29 41.43c7.59-2.47 17.24 6 25.65 6s18.06-8.43 25.66-6c7.87 2.56 10.7 15.13 17.25 19.89S178.29 65 183.1 71.6s-.26 18.36 2.3 26.23c2.46 7.59 13.55 14.17 13.55 22.56z"
    />
    <path
      className="icons_attributes_15_05_2019_Honest_svg__cls-3"
      d="M65.51 99a3.47 3.47 0 01.44.82 3.75 3.75 0 01.2 1.78 4.08 4.08 0 01-.21.88 4 4 0 01-.49.94 3.88 3.88 0 01-.7.76 4.07 4.07 0 01-.85.55 4 4 0 01-4-.36 4.05 4.05 0 01-.75-.69 3.87 3.87 0 01-.54-.85 4 4 0 01-.31-1 3.91 3.91 0 01.18-2 3.83 3.83 0 01.88-1.4 4.14 4.14 0 011.37-.91l.46 1a2.87 2.87 0 00-1.06.64 2.66 2.66 0 00-.66 1 2.6 2.6 0 00-.16 1.1 2.75 2.75 0 00.28 1 2.89 2.89 0 00.66.87 3.1 3.1 0 002.14.78 2.87 2.87 0 001.07-.25 2.79 2.79 0 001.54-1.51 3.08 3.08 0 00.14-.55 2.64 2.64 0 000-.56 2.35 2.35 0 00-.09-.54 2.09 2.09 0 00-.24-.51l-1.4-.51-.71 1.95-1-.36 1.11-3zM70.64 92.49l-2.18 3.79-6.52-3.75 2.18-3.79.91.52-1.61 2.8 1.88 1.08L66.52 91l.91.52-1.21 2.1 1.89 1.09L69.73 92zM76.28 85l-.67.81-6.51-.6 4.2 3.43-.72.88-5.82-4.75.67-.81 6.52.61-4.21-3.43.72-.89zM81.63 76.4a3 3 0 01.63 1.15 2.73 2.73 0 01.07 1.14 2.85 2.85 0 01-.38 1A3.39 3.39 0 0180.63 81a3.07 3.07 0 01-.69.27 3 3 0 01-.73.1 2.53 2.53 0 01-.75-.11 2.72 2.72 0 01-.73-.35 3.21 3.21 0 01-.67-.61L74 76.68l.87-.74 3.08 3.61a2 2 0 00.66.53 1.74 1.74 0 00.7.17 1.76 1.76 0 00.68-.12 2 2 0 00.59-.35 2.05 2.05 0 00.44-.53 1.79 1.79 0 00.23-.65 1.71 1.71 0 00-.06-.72 2 2 0 00-.42-.73l-3.08-3.61.87-.74zM87.5 75.78l-1 .62-4.05-6.33 1-.62zM96 71.39l-1 .44-5.58-3.4 2.27 4.92-1 .48-3.1-6.83 1-.44L94.13 70l-2.27-5 1-.48zM103.78 69l-4.21 1.15-2-7.25 4.21-1.15.28 1-3.06.89.57 2.1 2.34-.64.28 1-2.34.64.58 2.11 3.07-.85zM132.79 69a3.43 3.43 0 01-.78.52 3.76 3.76 0 01-.86.29 3.71 3.71 0 01-.89.08 4.07 4.07 0 01-.9-.13 4 4 0 01-1-.4 3.89 3.89 0 01-.82-.62 4.08 4.08 0 01-.63-.8 3.88 3.88 0 01-.55-1.95 3.84 3.84 0 01.13-1.07 3.92 3.92 0 01.4-1 4 4 0 01.62-.82 3.89 3.89 0 01.79-.62 3.94 3.94 0 01.92-.4 3.89 3.89 0 012.05 0 3.81 3.81 0 011.48.74 4.12 4.12 0 011 1.27l-1 .56a2.88 2.88 0 00-.74-1 2.74 2.74 0 00-2.19-.61 2.77 2.77 0 00-1 .38 2.88 2.88 0 00-.81.74 3.1 3.1 0 00-.57 2.2 2.87 2.87 0 00.35 1 2.8 2.8 0 001.75 1.33 2.86 2.86 0 00.56.09 2.61 2.61 0 00.56 0 2.29 2.29 0 00.53-.15 2 2 0 00.49-.28l.38-1.44-2-.52.26-1 3.11.81zM139.78 73.45l-4-1.81 3.12-6.84 4 1.81-.44 1-2.94-1.34-.9 2 2.21 1-.44 1-2.21-1-.91 2 2.94 1.34zM147.73 78.37l-.87-.59v-6.53l-3 4.5-.95-.64 4.19-6.24.87.59V76l3-4.51.95.64zM156.83 82.88a3 3 0 01-1.08.74 2.73 2.73 0 01-1.13.18 2.83 2.83 0 01-1.07-.28 3.41 3.41 0 01-1.38-1.2 3.06 3.06 0 01-.33-.66 3 3 0 01-.16-.72 2.54 2.54 0 010-.75 2.7 2.7 0 01.28-.75 3.21 3.21 0 01.54-.73l3.31-3.41.82.8-3.31 3.41a2 2 0 00-.46.71 1.73 1.73 0 00.08 1.38 2 2 0 001 .95 1.78 1.78 0 00.67.16 1.72 1.72 0 00.71-.13 2 2 0 00.69-.48l3.31-3.41.82.79zM158 88.68l-.7-.9 5.92-4.63.7.9zM163.18 96.76l-.53-.91 2.86-5.85-4.69 2.72-.57-1 6.5-3.78.53.91-2.86 5.88 4.7-2.73.57 1zM166.26 104.23l-1.55-4.09 7-2.66 1.55 4.09-1 .37-1.14-3-2 .77.88 2.29-1 .37-.86-2.27-2 .77 1.14 3z"
    />
    <circle
      className="icons_attributes_15_05_2019_Honest_svg__cls-2"
      cx={115.95}
      cy={62.5}
      r={4}
      transform="rotate(-45 115.946 62.494)"
    />
    <circle
      className="icons_attributes_15_05_2019_Honest_svg__cls-2"
      cx={174.5}
      cy={120.5}
      r={4}
      transform="rotate(-45 174.494 120.502)"
    />
    <circle
      className="icons_attributes_15_05_2019_Honest_svg__cls-2"
      cx={58.5}
      cy={120.5}
      r={4}
      transform="rotate(-45 58.502 120.498)"
    />
    <circle
      className="icons_attributes_15_05_2019_Honest_svg__cls-2"
      cx={115.95}
      cy={177.5}
      r={4}
      transform="rotate(-45 115.953 177.5)"
    />
    <path
      className="icons_attributes_15_05_2019_Honest_svg__cls-3"
      d="M166.06 142.29a3.47 3.47 0 01-.45-.82 3.73 3.73 0 01-.22-1.78 4 4 0 01.21-.88 4 4 0 01.48-.95 3.9 3.9 0 01.69-.76 4.07 4.07 0 01.85-.56 3.88 3.88 0 012-.39 4.05 4.05 0 012 .7 4 4 0 01.76.69 3.93 3.93 0 01.55.84 4 4 0 01.32 1 4 4 0 01-1 3.46 4.14 4.14 0 01-1.35.92l-.47-1a2.87 2.87 0 001.05-.65 2.67 2.67 0 00.65-1 2.64 2.64 0 00.15-1.1 2.78 2.78 0 00-.29-1 2.86 2.86 0 00-.67-.86 3.1 3.1 0 00-2.15-.76 2.87 2.87 0 00-1.07.26 2.79 2.79 0 00-1.47 1.63 2.93 2.93 0 00-.13.55 2.64 2.64 0 000 .56 2.35 2.35 0 00.1.54 2.11 2.11 0 00.24.51l1.4.5.69-2 1 .35-1.07 3zM161 148.89l2.13-3.81 6.56 3.67-2.13 3.81-.92-.51 1.58-2.81-1.9-1.06-1.18 2.12-.92-.51 1.18-2.12-1.91-1.07-1.58 2.82zM155.45 156.4l.66-.82 6.51.53-4.24-3.38.71-.89 5.88 4.69-.66.82-6.52-.54 4.25 3.39-.71.89zM150.2 165.1a3 3 0 01-.65-1.14 2.7 2.7 0 01-.08-1.14 2.86 2.86 0 01.37-1 3.42 3.42 0 01.71-.86 3.38 3.38 0 01.61-.42 3.1 3.1 0 01.69-.28 3 3 0 01.73-.1 2.51 2.51 0 01.75.1 2.73 2.73 0 01.73.34 3.21 3.21 0 01.68.6l3.12 3.58-.86.75-3.12-3.58a2 2 0 00-.67-.52 1.72 1.72 0 00-.7-.16 1.77 1.77 0 00-.68.13 2 2 0 00-1 .9 1.81 1.81 0 00-.22.66 1.73 1.73 0 00.07.72 2 2 0 00.43.73l3.12 3.58-.86.75zM144.33 165.78l1-.63 4.12 6.29-1 .63zM135.84 170.28l1-.45 5.62 3.33-2.32-4.9 1-.49 3.22 6.79-1 .45-5.62-3.34 2.33 4.91-1 .49zM128.13 172.72l4.2-1.2 2.06 7.23-4.2 1.2-.29-1 3.1-.89-.6-2.09-2.33.67-.29-1 2.33-.67-.6-2.1-3.1.89zM99.12 173.11a3.44 3.44 0 01.77-.53 3.72 3.72 0 01.85-.3 3.76 3.76 0 01.89-.09 4.06 4.06 0 01.9.12 4 4 0 011 .39 4 4 0 01.83.61 4 4 0 01.63.79 3.85 3.85 0 01.41.92 3.91 3.91 0 01.16 1 3.83 3.83 0 01-.12 1.07 3.9 3.9 0 01-.39 1 4 4 0 01-.61.82 3.85 3.85 0 01-.79.63 3.89 3.89 0 01-1.93.57 4 4 0 01-2.53-.84 4.13 4.13 0 01-1-1.26l1-.57a2.89 2.89 0 00.75 1 2.67 2.67 0 001.08.55 2.64 2.64 0 001.11 0 2.81 2.81 0 001-.39 2.91 2.91 0 00.8-.75 3.11 3.11 0 00.55-2.21 2.89 2.89 0 00-.36-1 2.8 2.8 0 00-1.76-1.31 3 3 0 00-.56-.08 2.58 2.58 0 00-.56 0 2.32 2.32 0 00-.53.15 2 2 0 00-.48.29l-.36 1.45 2 .5-.25 1-3.12-.78zM92.08 168.7l4 1.77-3 6.87-4-1.77.42-1 3 1.31.88-2-2.22-1 .43-1 2.22 1 .88-2-3-1.31zM84.08 163.87l.88.58L85 171l3-4.53 1 .63-4.12 6.29-.88-.58-.08-6.54-3 4.54-1-.63zM74.93 159.46a3 3 0 011.07-.75 2.73 2.73 0 011.13-.19 2.86 2.86 0 011.08.27 3.43 3.43 0 01.92.62 3.38 3.38 0 01.48.56 3.12 3.12 0 01.34.66 3 3 0 01.17.72 2.5 2.5 0 010 .75 2.73 2.73 0 01-.27.76 3.21 3.21 0 01-.53.73L76 167l-.83-.79 3.27-3.45a2 2 0 00.46-.71 1.73 1.73 0 00-.09-1.38 2 2 0 00-1-.94 1.79 1.79 0 00-.67-.16 1.72 1.72 0 00-.71.13 2 2 0 00-.69.49l-3.27 3.45-.83-.79zM73.69 153.67l.71.89-5.87 4.69-.71-.89zM68.42 145.65l.54.9-2.79 5.91 4.66-2.78.59 1-6.42 3.84-.54-.9 2.8-5.91-4.66 2.78-.58-1zM65.26 138.22l1.59 4.07-7 2.74-1.59-4.03 1-.38 1.18 3 2-.79-.88-2.26 1-.38.88 2.26 2-.8-1.17-3z"
    />
    <circle
      className="icons_attributes_15_05_2019_Honest_svg__cls-2"
      cx={115.95}
      cy={120.39}
      r={43.88}
    />
    <path
      className="icons_attributes_15_05_2019_Honest_svg__cls-3"
      d="M126.75 127.61l-5.62 2.49a5.39 5.39 0 00-1.46-2.65 6.93 6.93 0 00-3.21-1.85l-6.2-1.91a13.36 13.36 0 01-3.44-1.59 11.18 11.18 0 01-2.62-2.36 10.75 10.75 0 01-1.7-3 9.46 9.46 0 01-.61-3.37 12.36 12.36 0 011-5.25 11.11 11.11 0 016.6-6 13.69 13.69 0 014.45-.74 13.92 13.92 0 014.27.69 11.56 11.56 0 013.9 2.15 12.87 12.87 0 013 3.71 14.53 14.53 0 011.62 5.33l-5.51.69a10.21 10.21 0 00-1-3.15 7 7 0 00-1.7-2.2 7.09 7.09 0 00-2.2-1.27 7.3 7.3 0 00-2.46-.42 6.92 6.92 0 00-2.25.37 5.23 5.23 0 00-1.91 1.14 5.63 5.63 0 00-1.32 2 7.25 7.25 0 00-.5 2.84 4.41 4.41 0 001.17 2.94 6.42 6.42 0 003.07 1.93l6.68 2.07a12.19 12.19 0 015.2 2.8 10.1 10.1 0 012.75 4.61zM126.89 138.52a3.77 3.77 0 01-1.14 2.77 3.71 3.71 0 01-2.72 1.14 3.88 3.88 0 01-3.91-3.91 3.71 3.71 0 011.13-2.72 3.77 3.77 0 012.77-1.13 3.88 3.88 0 013.85 3.85z"
    />
  </svg>
);

IconHonest.defaultProps = { ...defaultProps };
IconHonest.propTypes = { ...iconPropTypes };

export const IconIndependent = ({ color, ...props }) => (
  <svg
    id="icons_attributes_15_05_2019_Independent_svg__icons"
    viewBox="0 0 240 240"
    {...props}
  >
    <defs>
      <style>
        {
          `
          .icons_attributes_15_05_2019_Independent_svg__cls-1 {
            fill: ${color};
          }`
        }
      </style>
    </defs>
    <path
      className="icons_attributes_15_05_2019_Independent_svg__cls-1"
      d="M116 200.29a1 1 0 01-.45-.11 43.63 43.63 0 01-20.49-22 .94.94 0 01.53-1.23 1 1 0 011.26.52 41.71 41.71 0 0019.59 21 .94.94 0 01.41 1.28 1 1 0 01-.85.54z"
    />
    <path
      className="icons_attributes_15_05_2019_Independent_svg__cls-1"
      d="M133.13 198.57h-.07c-19.71-1.37-35.15-17.55-35.15-36.84a1 1 0 011.94 0c0 18.3 14.65 33.65 33.35 34.95a.95.95 0 01-.07 1.89zM152.35 194.82a1 1 0 01-.87-.52.94.94 0 01.43-1.27 34.83 34.83 0 0019.8-31.31 34 34 0 00-2.49-12.81.94.94 0 01.55-1.23 1 1 0 011.26.53 35.87 35.87 0 012.62 13.5 36.71 36.71 0 01-20.87 33 1 1 0 01-.43.11z"
    />
    <path
      className="icons_attributes_15_05_2019_Independent_svg__cls-1"
      d="M135.64 192.38c-17.52 0-31.78-13.9-31.78-31a1 1 0 011.94 0c0 16 13.39 29.1 29.84 29.1A30.17 30.17 0 00153 185a1 1 0 011.35.22.93.93 0 01-.22 1.32 32.13 32.13 0 01-18.49 5.84zM163.93 174.28a1 1 0 01-.39-.08.94.94 0 01-.54-1.2 28 28 0 002.44-11.57c0-11.63-7.4-22.16-19.23-27.49a.94.94 0 01-.47-1.26 1 1 0 011.29-.46c12.52 5.64 20.32 16.83 20.36 29.2a29.88 29.88 0 01-2.6 12.33 1 1 0 01-.86.53z"
    />
    <path
      className="icons_attributes_15_05_2019_Independent_svg__cls-1"
      d="M135.49 186.22c-14.23 0-25.8-11.29-25.8-25.16a1 1 0 011.94 0c0 12.83 10.71 23.27 23.86 23.27s23.86-10.44 23.86-23.27a22.65 22.65 0 00-5-14.26 13.83 13.83 0 00-2.39-2.25 11 11 0 01-4.55-6.78 1 1 0 01.71-1.14 1 1 0 011.17.69 9.13 9.13 0 003.89 5.76 15.56 15.56 0 012.7 2.55 24.5 24.5 0 015.43 15.42c-.01 13.88-11.59 25.17-25.82 25.17z"
    />
    <path
      className="icons_attributes_15_05_2019_Independent_svg__cls-1"
      d="M135.35 180.17a19.72 19.72 0 01-19.94-19.45 18.68 18.68 0 012.49-9.63 1 1 0 011.33-.35.93.93 0 01.36 1.29 16.85 16.85 0 00-2.23 8.68 18 18 0 0036 0 17.6 17.6 0 00-12.22-16.62.94.94 0 01-.61-1.2 1 1 0 011.23-.59 19.5 19.5 0 0113.53 18.41 19.72 19.72 0 01-19.94 19.46z"
    />
    <path
      className="icons_attributes_15_05_2019_Independent_svg__cls-1"
      d="M135.21 174.24A14 14 0 01121 160.4a13.62 13.62 0 013.55-9.15 1 1 0 011.37-.08.93.93 0 01.09 1.34 11.76 11.76 0 00-3.07 7.9 12.26 12.26 0 1016.34-11.27.94.94 0 01-.59-1.21 1 1 0 011.24-.58 13.8 13.8 0 01-4.73 26.89z"
    />
    <path
      className="icons_attributes_15_05_2019_Independent_svg__cls-1"
      d="M135.07 168.42a8.35 8.35 0 118.56-8.35 8.46 8.46 0 01-8.56 8.35zm0-14.8a6.45 6.45 0 106.62 6.45 6.54 6.54 0 00-6.62-6.45zM163 62.62a1 1 0 01-.65-.24 65.17 65.17 0 00-16.83-10.55.94.94 0 01-.49-1.25 1 1 0 011.28-.48A67.11 67.11 0 01163.68 61a.93.93 0 01.08 1.34 1 1 0 01-.76.28zM57.23 82.17a1 1 0 01-.42-.09.94.94 0 01-.46-1.26 64.67 64.67 0 0124.12-26.3 68.94 68.94 0 0136.87-10.59 70.94 70.94 0 0114.81 1.59 1 1 0 01.74 1.13 1 1 0 01-1.16.72 68.94 68.94 0 00-14.39-1.55 67 67 0 00-35.81 10.29A62.77 62.77 0 0058.1 81.63a1 1 0 01-.87.54zM54.08 128.74a1 1 0 01-.93-.66 63.75 63.75 0 01-2-31.57 1 1 0 011.13-.75 1 1 0 01.72 1.1 61.89 61.89 0 002 30.65.94.94 0 01-.64 1.19 1 1 0 01-.28.04zM75.32 159.75a1 1 0 01-.65-.24 79.83 79.83 0 01-12.24-13.18 54.96 54.96 0 01-2.23-3.25.93.93 0 01.31-1.3 1 1 0 011.34.3c.68 1.07 1.41 2.13 2.16 3.15A78 78 0 0076 158.1a.93.93 0 01.08 1.34 1 1 0 01-.76.31zM101.63 198a1 1 0 01-.68-.27c-9.17-8.82-11.37-15.93-13.13-21.64a26.72 26.72 0 00-2.59-6.49.93.93 0 01.31-1.3 1 1 0 011.34.31 28 28 0 012.8 6.94c1.7 5.51 3.82 12.36 12.63 20.84a.93.93 0 010 1.34 1 1 0 01-.68.27zM181 140.65a1 1 0 01-1-.89c-.13-2.1-.8-13.37-1.19-19.9a1 1 0 011.94-.11c.39 6.53 1.06 17.8 1.19 19.9a1 1 0 01-.91 1z"
    />
    <path
      className="icons_attributes_15_05_2019_Independent_svg__cls-1"
      d="M58.49 99h-.18a1 1 0 01-.77-1.11C60.6 82.13 69.76 69 84 60a62.32 62.32 0 0133.33-9.57c15.25 0 31 5.76 42 15.41A59.57 59.57 0 01174 85.41a.94.94 0 01-.47 1.26 1 1 0 01-1.29-.46 57.68 57.68 0 00-14.18-18.93c-10.69-9.35-25.91-14.93-40.7-14.93a60.35 60.35 0 00-32.26 9.26C71.28 70.34 62.4 83 59.45 98.23a1 1 0 01-.96.77zM68.54 143.22a1 1 0 01-.79-.4A58.21 58.21 0 0156.81 114a1 1 0 01.87-1 1 1 0 011.06.85 56.35 56.35 0 0010.59 27.95.93.93 0 01-.22 1.32 1 1 0 01-.57.1zM101 187.72a1 1 0 01-.8-.4 46.39 46.39 0 01-8.2-20.71 18.22 18.22 0 00-.85-3.69c-1-2.1-1.64-2.44-3.67-3.43A43 43 0 0182.9 157a55.75 55.75 0 01-9.48-7.56.93.93 0 010-1.34 1 1 0 011.37 0 53.89 53.89 0 009.21 7.3 40.74 40.74 0 004.37 2.4c2.15 1 3.34 1.63 4.58 4.35a18.84 18.84 0 011 4.14 44.12 44.12 0 007.88 19.94.93.93 0 01-.24 1.32 1 1 0 01-.59.17zM178 153.81a1 1 0 01-.94-.7c-3.89-14.2-4.42-20.45-4.44-20.71l-.68-20a1 1 0 01.94-1 1 1 0 011 .91l.68 19.91s.54 6.33 4.38 20.32a1 1 0 01-.69 1.16 1 1 0 01-.25.11z"
    />
    <path
      className="icons_attributes_15_05_2019_Independent_svg__cls-1"
      d="M101.31 175.6a1 1 0 01-.89-.58A29.56 29.56 0 0198 161.09a8.2 8.2 0 00-.14-2.71c-.58-1.18-1.09-1.38-2.78-2a41.27 41.27 0 01-4.41-2A50.32 50.32 0 0173 139.4a52.18 52.18 0 01-9.13-40.18c2.73-14 10.93-25.73 23.71-33.8a55.83 55.83 0 0129.86-8.57c13.72 0 27.82 5.17 37.72 13.82a53.88 53.88 0 0114.3 20.11.94.94 0 01-.56 1.22 1 1 0 01-1.26-.52 52 52 0 00-13.79-19.41c-9.56-8.35-23.17-13.34-36.43-13.34A53.86 53.86 0 0088.61 67c-12.33 7.78-20.23 19-22.86 32.56a50.29 50.29 0 008.8 38.72 47.76 47.76 0 0017 14.41 38.89 38.89 0 004.21 1.87c1.82.7 2.91 1.13 3.82 3a8.12 8.12 0 01.33 3.58 27.9 27.9 0 002.3 13.14.94.94 0 01-.51 1.24 1 1 0 01-.39.08z"
    />
    <path
      className="icons_attributes_15_05_2019_Independent_svg__cls-1"
      d="M170.36 149.89a1 1 0 01-.88-.55 61 61 0 01-4.74-14.94c0-.16-.11-.38-.19-.64-.5-1.66-.88-3.12-.49-4.09.51-1.26 1.9-.94 2.49-.81l.4.08c.14-2.2-.57-11.65-1.37-20.07-.12-2-1.54-19.53-15.89-32.07A50.21 50.21 0 00117.45 65a48.46 48.46 0 00-9.34.91 1 1 0 01-1.14-.74 1 1 0 01.76-1.12 50.45 50.45 0 019.73-.95c12.21 0 24.75 4.58 33.53 12.26 14.92 13 16.41 31.3 16.53 33.34 2 20.5 1.34 21.19 1 21.56a2.34 2.34 0 01-2.41.41l-.28-.06a13.25 13.25 0 00.58 2.59c.1.32.18.59.22.78v.07a60.12 60.12 0 004.59 14.48.94.94 0 01-.48 1.26 1 1 0 01-.38.1zM72.82 95a1 1 0 01-.32 0 .94.94 0 01-.59-1.21A45.94 45.94 0 0191 70.72c1.28-.81 2.62-1.57 4-2.26a1 1 0 011.31.4.94.94 0 01-.41 1.28c-1.3.66-2.59 1.39-3.82 2.17a44.06 44.06 0 00-18.34 22.08 1 1 0 01-.92.61zM78.89 136.43a1 1 0 01-.79-.4 46.1 46.1 0 01-8.85-28.33 1 1 0 011-.92 1 1 0 01.95 1 44.22 44.22 0 008.48 27.18.93.93 0 01-.22 1.32 1 1 0 01-.57.15zM105 154.83a1 1 0 01-.85-.48c-.87-1.51-2-1.87-4.09-2.52a34.78 34.78 0 01-4.71-1.77 46.42 46.42 0 01-8.13-4.83.93.93 0 01-.22-1.33 1 1 0 011.36-.18 44.51 44.51 0 007.79 4.63 32.63 32.63 0 004.46 1.67c2.21.69 4 1.24 5.2 3.4a.93.93 0 01-.37 1.29 1 1 0 01-.44.12z"
    />
    <path
      className="icons_attributes_15_05_2019_Independent_svg__cls-1"
      d="M162.54 147.73a1 1 0 01-1-.85 67.1 67.1 0 00-2.47-12 33.52 33.52 0 00-3.56-7.06c-1.17-1.89-1.82-2.94-1.52-3.85.46-1.43 2.32-.94 4-.52a12.75 12.75 0 002 .41c.25-1.63 0-8.43-.51-14.52-.1-1.72-1.33-17-13.85-27.92a43.8 43.8 0 00-28.13-10.24 41.24 41.24 0 00-22.06 6.32C86 83.45 80 92 78 102.19a36.26 36.26 0 00-.63 8.17 1 1 0 01-.94 1 1 1 0 01-1-.91 38.07 38.07 0 01.66-8.59c2.08-10.73 8.4-19.69 18.27-25.92a43.22 43.22 0 0123.12-6.63A45.82 45.82 0 01146.91 80c13.09 11.46 14.39 27.45 14.49 29.23.73 9.69.79 15 .15 15.89-.76 1-2.37.61-4.07.16-.39-.1-1-.25-1.39-.33.26.51.72 1.25 1.11 1.89a35.15 35.15 0 013.75 7.46 67.67 67.67 0 012.55 12.38 1 1 0 01-.87 1zm-6.65-23.3zM110.69 162.87a1 1 0 01-1-.87 20.25 20.25 0 011.14-9.09c.44-1.29.64-1.93.4-2.59-.45-1.25-3.36-2-5.49-2.61-.73-.2-1.42-.38-2-.58-5.73-1.92-14.1-5.51-20.63-14.4a39.55 39.55 0 01-5.86-11.65.94.94 0 01.65-1.18 1 1 0 011.21.63 37.68 37.68 0 005.58 11.1c6.21 8.45 14.21 11.87 19.69 13.71.53.18 1.2.36 1.9.55 2.82.76 6 1.62 6.8 3.8.47 1.29.07 2.46-.39 3.81a18.36 18.36 0 00-1.05 8.34 1 1 0 01-.89 1z"
    />
    <path
      className="icons_attributes_15_05_2019_Independent_svg__cls-1"
      d="M117.07 156.81h-.22a1 1 0 01-.73-1.14 17.74 17.74 0 012.47-5.65c.86-1.38 1.22-2 .94-3-.18-.62-1.16-1.59-4.81-2.66a.94.94 0 01-.65-1.18 1 1 0 011.21-.63c2.53.74 5.51 1.86 6.11 4 .52 1.8-.25 3.05-1.15 4.5a15.86 15.86 0 00-2.24 5.1 1 1 0 01-.93.66zm-10.3-14.75a1 1 0 01-.31 0c-5.62-1.82-12.8-4.88-18.4-12.5a34.29 34.29 0 01-6-26.39C83.82 94 89.23 86.36 97.68 81a37.09 37.09 0 0119.84-5.68 39.53 39.53 0 0125.39 9.23c11.2 9.79 12.38 23.43 12.49 25.13.26 2 .95 8.48-.79 10.25-1.3 1.33-4.34 1.14-7 1-.5 0-1.09-.07-1.6-.08a9.42 9.42 0 011.78 1.67c4.75 5.86 6.86 11 7.35 13l.53 2.24a1 1 0 01-.73 1.13 1 1 0 01-1.16-.71l-.53-2.24c0-.21-1.3-5.28-7-12.29a8 8 0 00-1.56-1.43c-.69-.52-1.56-1.16-1.2-2.33s1.72-1 4.23-.9c1.69.1 4.82.29 5.5-.4s.73-5.13.26-8.73v-.07c-.09-1.46-1.15-14.51-11.85-23.86a37.51 37.51 0 00-24.09-8.74 35.11 35.11 0 00-18.79 5.38c-8 5-13.11 12.26-14.78 20.85a32.4 32.4 0 005.68 24.93c5.28 7.18 12.09 10.08 17.43 11.81a.94.94 0 01.62 1.2 1 1 0 01-.93.69zm15.47-29.58l-2.58-.69s-3.78-1.08-3.62-2.65a1.43 1.43 0 01.76-1.1 2.24 2.24 0 011.77-.2 4.15 4.15 0 011.66 1.77c.15.24.31.48.48.73zm-5.24-3.26z"
    />
    <path
      className="icons_attributes_15_05_2019_Independent_svg__cls-1"
      d="M148.56 139.45a1 1 0 01-.95-.74l-.4-1.69c-.18-.75-1.28-4.74-5.65-9.74-5-5.78-14.4-8.26-21.92-10.26l-.2-.05-3-.8a8.52 8.52 0 01-5.65-4.29 5.12 5.12 0 01.09-4.55 7.28 7.28 0 016.76-4.24 11.64 11.64 0 014.07.79c4.5 1.68 5.34 7.13 5.38 7.36a4.47 4.47 0 002.64 2.92c2.53 1.23 15.85 1.45 17.16.27.9-1 .77-3.29.65-4v-.09c0-.14-.06-.9-.26-2.08a1 1 0 01.8-1.09 1 1 0 011.12.78c.2 1.17.26 2 .28 2.23.08.55.49 3.8-1.15 5.56-2.13 2.27-17 1.35-19.46.14a6.3 6.3 0 01-3.7-4.35s-.7-4.58-4.15-5.86a9.67 9.67 0 00-3.37-.66 5.29 5.29 0 00-5 3.17 3.27 3.27 0 00-.06 2.95 6.63 6.63 0 004.42 3.24l2.93.79.2.05c7.78 2.06 17.46 4.64 22.89 10.86 4.66 5.34 5.87 9.72 6.06 10.54l.4 1.69a1 1 0 01-.73 1.13z"
    />
    <path
      className="icons_attributes_15_05_2019_Independent_svg__cls-1"
      d="M100.4 133a1 1 0 01-.53-.16 25.71 25.71 0 01-7-6.53 28.54 28.54 0 01-5-22c1.46-7.54 6-13.88 13-18.34a31.09 31.09 0 0116.63-4.76A33.35 33.35 0 01139 89a30.21 30.21 0 017.5 10.12.94.94 0 01-.48 1.25 1 1 0 01-1.29-.47 28.34 28.34 0 00-7-9.49 31.33 31.33 0 00-20.14-7.27A29.11 29.11 0 00102 87.62c-6.61 4.17-10.82 10.09-12.19 17.1a26.65 26.65 0 004.68 20.51 23.82 23.82 0 006.45 6 .93.93 0 01.28 1.31 1 1 0 01-.82.46zM124.86 153.33a1 1 0 01-.65-.25.93.93 0 01-.06-1.34 6.84 6.84 0 001.45-7.32c-.53-1.28-1.08-2.6-4.62-3.92a68.54 68.54 0 00-6.95-2.16c-1.71-.45-3.46-.92-5.23-1.48a.94.94 0 01-.63-1.19 1 1 0 011.22-.61c1.73.54 3.46 1 5.13 1.45a70.34 70.34 0 017.15 2.22c4 1.5 5 3.21 5.72 5a8.71 8.71 0 01-1.82 9.31 1 1 0 01-.71.29z"
    />
    <path
      className="icons_attributes_15_05_2019_Independent_svg__cls-1"
      d="M131.12 144.14l-.24-1.16c0-.22-1.14-5-7.35-7.45a72.15 72.15 0 00-8-2.46c-6.51-1.73-13.25-3.52-17.89-9.84a22.92 22.92 0 01-4-17.63c1.16-6 4.79-11.05 10.5-14.66 10.64-6.72 23.93-3.75 31 2.46 7.9 6.9 8.58 16.88 8.61 17.3l.05.91-12.34 1.14-.13-.9c0-.09-1.35-8.68-8.34-11.23-6.61-2.41-12.46-.43-15.28 5.18a8.52 8.52 0 00-.15 7.48 12 12 0 007.93 6.22c1 .28 2.09.57 3.21.87 7 1.87 15.82 4.2 20.14 9.15 4 4.57 4.86 8.12 4.89 8.27l.18.76zM117.62 89a23.13 23.13 0 00-12.44 3.53c-5.25 3.31-8.58 8-9.64 13.42a21 21 0 003.7 16.18c4.24 5.77 10.35 7.4 16.82 9.12a73.6 73.6 0 018.21 2.53 13.84 13.84 0 018.17 7.72l9.18-4a22.7 22.7 0 00-4.24-6.74c-3.93-4.51-12.38-6.75-19.17-8.55-1.13-.3-2.22-.59-3.24-.87a13.93 13.93 0 01-9.17-7.27 10.34 10.34 0 01.2-9.07c3.24-6.46 10.19-8.87 17.7-6.12 6.72 2.46 8.85 9.36 9.41 11.85l8.62-.8c-.36-2.54-1.89-9.88-7.86-15.09A25.27 25.27 0 00117.62 89zM139.64 149.2a1 1 0 01-.33-.06 3.63 3.63 0 01-2.26-4.67 3.77 3.77 0 014.8-2.18.94.94 0 01.58 1.21 1 1 0 01-1.24.57 1.82 1.82 0 00-2.31 1 1.75 1.75 0 001.09 2.25.94.94 0 01.58 1.21 1 1 0 01-.91.67z"
    />
    <path
      className="icons_attributes_15_05_2019_Independent_svg__cls-1"
      d="M142.73 139.07l-11 4.86a10.52 10.52 0 00-2.84-5.17 13.52 13.52 0 00-6.26-3.62l-12.1-3.72a26.06 26.06 0 01-6.72-3.1 21.82 21.82 0 01-5.12-4.6 21 21 0 01-3.31-5.79 18.45 18.45 0 01-1.19-6.57 24.11 24.11 0 012-10.24 21.68 21.68 0 0112.87-11.68 26.72 26.72 0 018.75-1.44 27.15 27.15 0 018.32 1.34 22.56 22.56 0 017.6 4.19 25.1 25.1 0 015.84 7.24 28.34 28.34 0 013.15 10.39L132 112.5a19.91 19.91 0 00-1.86-6.15 13.6 13.6 0 00-3.31-4.29 13.83 13.83 0 00-4.29-2.48 14.25 14.25 0 00-4.81-.83 13.51 13.51 0 00-4.39.72 10.21 10.21 0 00-3.72 2.22 11 11 0 00-2.58 3.83 14.15 14.15 0 00-1 5.53 8.61 8.61 0 002.27 5.74 12.53 12.53 0 006 3.77l13 4a23.78 23.78 0 0110 5.58 19.7 19.7 0 015.42 8.93zM143 160.38a7.36 7.36 0 01-2.22 5.41 7.24 7.24 0 01-5.3 2.22 7.56 7.56 0 01-7.62-7.62 7.24 7.24 0 012.21-5.31 7.36 7.36 0 015.41-2.21 7.56 7.56 0 017.52 7.52z"
    />
  </svg>
);

IconIndependent.defaultProps = { ...defaultProps };
IconIndependent.propTypes = { ...iconPropTypes };

export const IconInquisitive = ({ color, ...props }) => (
  <svg
    id="icons_attributes_15_05_2019_Inqusitive_svg__icons"
    viewBox="0 0 240 240"
    {...props}
  >
    <defs>
      <style>
        {
          `.icons_attributes_15_05_2019_Inqusitive_svg__cls-1 {
            fill: none;
            stroke: ${color};
            stroke-miterlimit: 10;
            stroke-width: 4px;
          }
          .icons_attributes_15_05_2019_Inqusitive_svg__cls-2{
            fill: ${color};
          }`
        }
      </style>
    </defs>
    <path
      className="icons_attributes_15_05_2019_Inqusitive_svg__cls-1"
      d="M108.19 163.54a14 14 0 00-1.54-6.27l9.13-15.82 17.07-1.06 39.52 23.18 29.22-49.8-19.85-11.65-67.25-39.45M87.73 47L58.51 96.78l39.86 23.38 7.63 14.16-9 15.5a14.18 14.18 0 00-2.89-.31 14 14 0 00-12.62 8H59.32v-9.79H43.06v-10.3H26.79V193h16.27v-11.43h16.26v-12h22.23a14 14 0 0012.62 8M203.91 124.76l-20.92 35.66 16.33 3.77L215.13 137l-11.22-12.24zM107.78 163.89A13.75 13.75 0 1094 177.64M59.28 155.14v19"
    />
    <circle
      className="icons_attributes_15_05_2019_Inqusitive_svg__cls-1"
      cx={94.28}
      cy={164.14}
      r={5}
    />
    <path
      className="icons_attributes_15_05_2019_Inqusitive_svg__cls-2"
      d="M110.13 81.75l-5.62 2.49a5.39 5.39 0 00-1.46-2.65 6.93 6.93 0 00-3.21-1.85l-6.2-1.91a13.36 13.36 0 01-3.44-1.59 11.18 11.18 0 01-2.62-2.36 10.75 10.75 0 01-1.7-3 9.46 9.46 0 01-.61-3.37 12.36 12.36 0 011-5.25 11.11 11.11 0 016.6-6 13.69 13.69 0 014.45-.74 13.92 13.92 0 014.27.69 11.56 11.56 0 013.9 2.15 12.87 12.87 0 013 3.71 14.53 14.53 0 011.62 5.33l-5.51.69a10.21 10.21 0 00-1-3.15 7 7 0 00-1.7-2.2 7.09 7.09 0 00-2.2-1.27 7.3 7.3 0 00-2.46-.42 6.92 6.92 0 00-2.25.37 5.23 5.23 0 00-1.91 1.14 5.63 5.63 0 00-1.32 2 7.25 7.25 0 00-.5 2.84 4.41 4.41 0 001.17 2.94 6.42 6.42 0 003.07 1.93l6.68 2.07a12.19 12.19 0 015.11 2.86 10.1 10.1 0 012.84 4.55zM110.28 92.67a3.77 3.77 0 01-1.14 2.77 3.71 3.71 0 01-2.72 1.14 3.88 3.88 0 01-3.91-3.91 3.71 3.71 0 011.14-2.67 3.77 3.77 0 012.77-1.13 3.88 3.88 0 013.85 3.85z"
    />
  </svg>
);

IconInquisitive.defaultProps = { ...defaultProps };
IconInquisitive.propTypes = { ...iconPropTypes };

export const IconLeadership = ({ color, ...props }) => (
  <svg
    id="icons_attributes_15_05_2019_Leadership_svg__icons"
    viewBox="0 0 240 240"
    {...props}
  >
    <defs>
      <style>
        {
          `.icons_attributes_15_05_2019_Leadership_svg__cls-1 {
            fill: none;
            stroke: ${color};
            stroke-miterlimit: 10;
            stroke-width: 4px
          }
          .icons_attributes_15_05_2019_Leadership_svg__cls-2{
            fill: ${color}
          }`
        }
      </style>
    </defs>
    <path
      className="icons_attributes_15_05_2019_Leadership_svg__cls-1"
      d="M71.5 81.75h51.86a22.42 22.42 0 017.12 1.16l73 18.47a5.31 5.31 0 013.72 7 12.58 12.58 0 01-13.85 8.08l-37.75-6.94M72.13 156.24h29.65a15.24 15.24 0 0113.85 8.89"
    />
    <path
      className="icons_attributes_15_05_2019_Leadership_svg__cls-1"
      d="M101.2 156.24l8.74 12.59a12.72 12.72 0 0010.45 5.47h1a12 12 0 009.75-5l1.75-2.43a11.18 11.18 0 00-.05-13.14l-9.61-13.11M137.39 159.72h1a12 12 0 009.75-5l1.24-1.73a12.38 12.38 0 00-.06-14.55l-9.09-12.4M154.39 145.15h1a12 12 0 009.75-5l1.74-2.41a11.21 11.21 0 00-.05-13.18l-9.59-13.09c-10.38-11.89-23.31-17-38.63-15.74"
    />
    <path
      className="icons_attributes_15_05_2019_Leadership_svg__cls-2"
      d="M59.14 135.81a13.63 13.63 0 014.11 5.1l3.52 7a7.18 7.18 0 002.7 3 4.93 4.93 0 003.46.74 8.11 8.11 0 003-1.08 6.29 6.29 0 001.91-1.83 5.85 5.85 0 00.9-2.31 7.74 7.74 0 000-2.55 8.16 8.16 0 00-.93-2.64 7.93 7.93 0 00-1.81-2.18 7.79 7.79 0 00-2.74-1.46 11.41 11.41 0 00-3.65-.46l-.27-6.2a16.24 16.24 0 016.17.79 14.38 14.38 0 014.65 2.61 12.92 12.92 0 013.09 3.89 15.56 15.56 0 011.55 4.57 15.31 15.31 0 010 5 12.42 12.42 0 01-5.37 8.39 13.81 13.81 0 01-5.59 2.11 10.57 10.57 0 01-3.82 0 12 12 0 01-3.55-1.3 12.5 12.5 0 01-3.09-2.45A14.93 14.93 0 0161 151l-3.26-6.48a7.75 7.75 0 00-2.64-3.19 6 6 0 00-3.19-1.11l1.7-6.65a11.29 11.29 0 015.53 2.24zM44.75 136.21A4.15 4.15 0 0146.5 139a4.22 4.22 0 01-.73 3.27A4.15 4.15 0 0143 144a4.33 4.33 0 01-5-3.58 4.15 4.15 0 01.75-3.21 4.22 4.22 0 012.84-1.77 4.15 4.15 0 013.16.77z"
    />
  </svg>
);

IconLeadership.defaultProps = { ...defaultProps };
IconLeadership.propTypes = { ...iconPropTypes };

export const IconMathematical = ({ color, ...props }) => (
  <svg
    id="icons_attributes_15_05_2019_Mathematical_svg__icons"
    viewBox="0 0 240 240"
    {...props}
  >
    <defs>
      <style>
        {
          `
          .icons_attributes_15_05_2019_Mathematical_svg__cls-1,
          .icons_attributes_15_05_2019_Mathematical_svg__cls-3 {
            fill: none;
            stroke: ${color};
            stroke-width: 4px;
          }
          .icons_attributes_15_05_2019_Mathematical_svg__cls-1 {
            stroke-linecap: round; 
            stroke-linejoin: round;
          }
          .icons_attributes_15_05_2019_Mathematical_svg__cls-3 {
            stroke-miterlimit: 10;
          }
          .icons_attributes_15_05_2019_Mathematical_svg__cls-4 {
            fill: ${color};
          }`
        }
      </style>
    </defs>
    <path
      className="icons_attributes_15_05_2019_Mathematical_svg__cls-1"
      d="M43.53 164l77.64 45.99v-91.22L43.53 74.68v70.61"
    />
    <path
      className="icons_attributes_15_05_2019_Mathematical_svg__cls-1"
      d="M173.63 60.36l-25.14 14.32m-105 60.12l77.64 43.16 26-14.7M95.36 194.7v-90.59l25.82-14.33m-50.84 90.1v-90l25.37-15.2m103.65 22.11v68.91l-26 14.7M95.71 45.09L122.47 30l76.89 45.61M43.53 103.7l77.64 44.47 26-15.08"
    />
    <path fill="none" d="M161.6 155.73l27.42-14.7-54.84-93.85-23.25 13.4" />
    <path
      className="icons_attributes_15_05_2019_Mathematical_svg__cls-3"
      d="M107.69 80.79l-.42-16.91 25.91-14.7 54.84 93.85-27.42 14.7-11.24-5.27"
    />
    <path
      className="icons_attributes_15_05_2019_Mathematical_svg__cls-1"
      d="M199.36 134.79l-12.55 5.46m12.55-35l-25.1 13.57m25.1-43.16L173 89.78m-24.51-44.33l-12.31 8.16m-15 65.17l26-13.57M43.53 74.68L70.29 59.6l76.89 45.61v90.08l-26 14.7m49.91-96.65l-22.45 12.59m4-44.24l-23.36 12.9"
    />
    <path
      className="icons_attributes_15_05_2019_Mathematical_svg__cls-4"
      d="M86 144.38l-2.39.69a2.18 2.18 0 00-.44-1.14A2.8 2.8 0 0082 143l-2.38-1.1a5.4 5.4 0 01-1.29-.82 4.52 4.52 0 01-.92-1.09 4.35 4.35 0 01-.52-1.28 3.82 3.82 0 01-.06-1.38 5 5 0 01.7-2 4.49 4.49 0 013-2 5.54 5.54 0 011.82-.06 5.63 5.63 0 011.67.51 4.67 4.67 0 011.44 1.07 5.2 5.2 0 011 1.65 5.87 5.87 0 01.36 2.22h-2.25a4.13 4.13 0 00-.21-1.32 2.82 2.82 0 00-.56-1 2.87 2.87 0 00-.81-.63 3 3 0 00-1-.3 2.8 2.8 0 00-.92 0 2.12 2.12 0 00-.83.35 2.28 2.28 0 00-.64.71 2.93 2.93 0 00-.35 1.11 1.78 1.78 0 00.31 1.24 2.6 2.6 0 001.13.94l2.6 1.18a4.93 4.93 0 011.89 1.42 4.08 4.08 0 01.82 1.96zM85.52 148.76a1.52 1.52 0 01-.61 1 1.5 1.5 0 01-1.15.31 1.57 1.57 0 01-1.35-1.78 1.5 1.5 0 01.6-1 1.53 1.53 0 011.17-.3 1.57 1.57 0 011.34 1.75z"
    />
    <path
      className="icons_attributes_15_05_2019_Mathematical_svg__cls-3"
      d="M147.69 131.79l15 26M109.69 62.79l17 30"
    />
    <path
      className="icons_attributes_15_05_2019_Mathematical_svg__cls-1"
      d="M160.6 157.73l-11.24-5.27-.85-1.46.43 14.58L173 180v-28.92l-12.4 6.65zM173 117.33V89.78l-24.05-13.62L173 117.33zM107.69 80.79l-.42-16.91 9.98-5.66-22.31-12.64.42 27.95 12.58 7.69-.25-.43z"
    />
  </svg>
);

IconMathematical.defaultProps = { ...defaultProps };
IconMathematical.propTypes = { ...iconPropTypes };

export const IconObservant = ({ color, ...props }) => (
  <svg
    id="icons_attributes_15_05_2019_Observant_svg__icons"
    viewBox="0 0 240 240"
    {...props}
  >
    <defs>
      <style>
        {
          `
          .icons_attributes_15_05_2019_Observant_svg__cls-1 {
            fill: none;
            stroke: ${color};
            stroke-linejoin: bevel;
            stroke-width: 4px
          }
          .icons_attributes_15_05_2019_Observant_svg__cls-2 {
            fill: ${color};
          }`
        }
      </style>
    </defs>
    <path
      className="icons_attributes_15_05_2019_Observant_svg__cls-1"
      d="M154.69 123.93a38.29 38.29 0 11-38.29-38.29M41 123.93s32.52 38.29 75.44 38.29 75.44-38.29 75.44-38.29-32.52-38.29-75.44-38.29S41 123.93 41 123.93z"
    />
    <path
      className="icons_attributes_15_05_2019_Observant_svg__cls-2"
      d="M128.75 129.61l-5.62 2.49a5.39 5.39 0 00-1.46-2.65 6.93 6.93 0 00-3.21-1.85l-6.2-1.91a13.36 13.36 0 01-3.44-1.59 11.18 11.18 0 01-2.62-2.36 10.75 10.75 0 01-1.7-3 9.46 9.46 0 01-.61-3.37 12.36 12.36 0 011-5.25 11.11 11.11 0 016.6-6 13.69 13.69 0 014.45-.74 13.92 13.92 0 014.27.69 11.56 11.56 0 013.9 2.15 12.87 12.87 0 013 3.71 14.53 14.53 0 011.62 5.33l-5.51.69a10.21 10.21 0 00-1-3.15 7 7 0 00-1.7-2.2 7.09 7.09 0 00-2.2-1.27 7.3 7.3 0 00-2.46-.42 6.92 6.92 0 00-2.25.37 5.23 5.23 0 00-1.91 1.14 5.63 5.63 0 00-1.32 2 7.25 7.25 0 00-.5 2.84 4.41 4.41 0 001.17 2.94 6.42 6.42 0 003.07 1.93l6.68 2.07a12.19 12.19 0 015.2 2.8 10.1 10.1 0 012.75 4.61zM128.89 140.52a3.77 3.77 0 01-1.14 2.77 3.71 3.71 0 01-2.72 1.14 3.88 3.88 0 01-3.91-3.91 3.71 3.71 0 011.13-2.72 3.77 3.77 0 012.77-1.13 3.88 3.88 0 013.85 3.85z"
    />
  </svg>
);

IconObservant.defaultProps = { ...defaultProps };
IconObservant.propTypes = { ...iconPropTypes };

export const IconPerfectionist = ({ color, ...props }) => (
  <svg
    id="icons_attributes_15_05_2019_Perfectionist_svg__icons"
    viewBox="0 0 240 240"
    {...props}
  >
    <defs>
      <style>
        {
          `
          .icons_attributes_15_05_2019_Perfectionist_svg__cls-1 {
            fill: none;
            stroke: ${color};
            stroke-miterlimit: 10;
            stroke-width: 4px
          }
          .icons_attributes_15_05_2019_Perfectionist_svg__cls-2 {
            fill: ${color};
          }`
        }
      </style>
    </defs>
    <path
      className="icons_attributes_15_05_2019_Perfectionist_svg__cls-1"
      d="M106 53.59h94M70.87 32.57a24.51 24.51 0 11-12.58-3.47M106 124.14h94M70.87 103.05a24.51 24.51 0 11-12.58-3.47M106 194.63h94M70.87 173.54a24.51 24.51 0 11-12.58-3.47"
    />
    <path
      className="icons_attributes_15_05_2019_Perfectionist_svg__cls-2"
      d="M62.94 196.71l-2.25 1a2.16 2.16 0 00-.58-1.06 2.77 2.77 0 00-1.28-.74l-2.48-.76a5.34 5.34 0 01-1.35-.65 4.47 4.47 0 01-1-.94 4.3 4.3 0 01-.68-1.19A3.78 3.78 0 0153 191a4.94 4.94 0 01.41-2.1 4.44 4.44 0 012.64-2.4 5.48 5.48 0 011.78-.3 5.57 5.57 0 011.71.28 4.62 4.62 0 011.56.86 5.15 5.15 0 011.2 1.48 5.81 5.81 0 01.65 2.13l-2.2.28a4.08 4.08 0 00-.38-1.26 2.79 2.79 0 00-.68-.88 2.84 2.84 0 00-.88-.51 2.92 2.92 0 00-1-.17 2.77 2.77 0 00-.9.15 2.09 2.09 0 00-.76.46 2.25 2.25 0 00-.53.78 2.9 2.9 0 00-.2 1.13 1.76 1.76 0 00.47 1.18 2.57 2.57 0 001.23.77l2.67.83a4.88 4.88 0 012 1.14 4 4 0 011.15 1.86zM63 201.08a1.51 1.51 0 01-.45 1.11 1.48 1.48 0 01-1.09.45 1.55 1.55 0 01-1.56-1.56 1.49 1.49 0 01.45-1.09 1.51 1.51 0 011.11-.45 1.55 1.55 0 011.54 1.54z"
    />
    <path
      className="icons_attributes_15_05_2019_Perfectionist_svg__cls-2"
      transform="rotate(-42.06 50.358 126.943)"
      d="M49.36 123.19h2v7.52h-2z"
    />
    <path
      className="icons_attributes_15_05_2019_Perfectionist_svg__cls-2"
      transform="rotate(-46.52 60.958 124.009)"
      d="M49.7 123h22.48v2H49.7z"
    />
    <path
      className="icons_attributes_15_05_2019_Perfectionist_svg__cls-2"
      transform="rotate(-42.06 50.355 56.947)"
      d="M49.36 53.19h2v7.52h-2z"
    />
    <path
      className="icons_attributes_15_05_2019_Perfectionist_svg__cls-2"
      transform="rotate(-46.52 60.948 54.009)"
      d="M49.7 53h22.48v2H49.7z"
    />
  </svg>
);

IconPerfectionist.defaultProps = { ...defaultProps };
IconPerfectionist.propTypes = { ...iconPropTypes };

export const IconStrategic = ({ color, ...props }) => (
  <svg
    id="icons_attributes_15_05_2019_Strategic_svg__icons"
    viewBox="0 0 240 240"
    {...props}
  >
    <defs>
      <style>
        {
          `
          .icons_attributes_15_05_2019_Strategic_svg__cls-1 {
            fill: none;
            stroke: ${color};
            stroke-miterlimit: 10;
            stroke-width: 4px
          }
          .icons_attributes_15_05_2019_Strategic_svg__cls-2 {
            fill: ${color};
          }`
        }
      </style>
    </defs>
    <path
      className="icons_attributes_15_05_2019_Strategic_svg__cls-1"
      d="M135.51 102c0-6.07.21-10 .21-10h-23.94s2.18 39-7.62 61c-11.04 24.83-20.66 28-20.66 48 0 1 40.25.5 40.25.5S164 202 164 201c0-20-9.62-23.17-20.67-48-4.19-9.42-6.19-22-7.11-33.23"
    />
    <path
      className="icons_attributes_15_05_2019_Strategic_svg__cls-2"
      d="M116.9 39.23L95 47l59 .09-22.96-7.33-14.14-.53z"
    />
    <rect
      className="icons_attributes_15_05_2019_Strategic_svg__cls-1"
      x={118.04}
      y={34.63}
      width={12.13}
      height={6.35}
      rx={3.18}
      ry={3.18}
      transform="rotate(.36 124.26 37.807)"
    />
    <rect
      className="icons_attributes_15_05_2019_Strategic_svg__cls-2"
      x={121.08}
      y={11.77}
      width={6.35}
      height={5.08}
      rx={2.54}
      ry={2.54}
      transform="rotate(.36 124.185 13.934)"
    />
    <path
      className="icons_attributes_15_05_2019_Strategic_svg__cls-2"
      d="M123.92 16.85h.16zM132.14 23.25a8.64 8.64 0 01-4.45 0s3.19-1.89 3.2-3.79c0-1.07-4.92-2.17-6.5-2.49v-.06h-.32v.06c-1.58.3-6.52 1.34-6.53 2.41 0 1.91 3.15 3.83 3.15 3.83a8.64 8.64 0 01-4.45 0v5.72l4.45-.61-3.84 4.42 5.07 1.94h4.45l5.09-1.87-3.78-4.47 4.44.66zM124.4 16.85h.16z"
    />
    <rect
      className="icons_attributes_15_05_2019_Strategic_svg__cls-1"
      x={105}
      y={74.92}
      width={37}
      height={9.08}
      rx={4.13}
      ry={4.13}
    />
    <path
      className="icons_attributes_15_05_2019_Strategic_svg__cls-2"
      d="M109.78 86l27 .17v.08a2.7 2.7 0 01-2.7 2.68l-21.58-.14a2.7 2.7 0 01-2.68-2.71V86m-3.86-4l-.14 3.81v.26a6.71 6.71 0 006.65 6.75l21.58.14a6.72 6.72 0 006.74-6.65V86l-.1-3.81h-3.87l-27-.17h-3.88zM181.2 216.84a4.06 4.06 0 014 4v.12H62.58v-.12a4.06 4.06 0 014-4H181.2m0-4H66.61a8.05 8.05 0 00-8 8v.3l.09 3.86h130.41l.12-3.82v-.3a8.05 8.05 0 00-8-8z"
    />
    <path
      className="icons_attributes_15_05_2019_Strategic_svg__cls-1"
      d="M168.89 212.26h-90V212a9 9 0 019-9h72a9 9 0 019 9c.02.09.01.18 0 .26zM108.54 75.05h31.27L151 49H97.37z"
    />
  </svg>
);

IconStrategic.defaultProps = { ...defaultProps };
IconStrategic.propTypes = { ...iconPropTypes };

export const IconTeamPlayer = ({ color, ...props }) => (
  <svg
    id="icons_attributes_15_05_2019_Team_Player_svg__icons"
    viewBox="0 0 240 240"
    {...props}
  >
    <defs>
      <style>
        {
          `.icons_attributes_15_05_2019_Team_Player_svg__cls-1 {
            fill: ${color}
          }
          .icons_attributes_15_05_2019_Team_Player_svg__cls-2,
          .icons_attributes_15_05_2019_Team_Player_svg__cls-3,
          .icons_attributes_15_05_2019_Team_Player_svg__cls-4 {
            fill: none;
            stroke: ${color};
            stroke-miterlimit: 10
          }
          .icons_attributes_15_05_2019_Team_Player_svg__cls-2 {
            stroke-width: 3px
          }
          .icons_attributes_15_05_2019_Team_Player_svg__cls-3,
          .icons_attributes_15_05_2019_Team_Player_svg__cls-4 {
            stroke-width: 2px
          }
          .icons_attributes_15_05_2019_Team_Player_svg__cls-3 {
            stroke-dasharray: 6
          }`
        }
      </style>
    </defs>
    <path
      className="icons_attributes_15_05_2019_Team_Player_svg__cls-1"
      d="M128.75 129.61l-5.62 2.49a5.39 5.39 0 00-1.46-2.65 6.93 6.93 0 00-3.21-1.85l-6.2-1.91a13.36 13.36 0 01-3.44-1.59 11.18 11.18 0 01-2.62-2.36 10.75 10.75 0 01-1.7-3 9.46 9.46 0 01-.61-3.37 12.36 12.36 0 011-5.25 11.11 11.11 0 016.6-6 13.69 13.69 0 014.45-.74 13.92 13.92 0 014.27.69 11.56 11.56 0 013.9 2.15 12.87 12.87 0 013 3.71 14.53 14.53 0 011.62 5.33l-5.51.69a10.21 10.21 0 00-1-3.15 7 7 0 00-1.7-2.2 7.09 7.09 0 00-2.2-1.27 7.3 7.3 0 00-2.46-.42 6.92 6.92 0 00-2.25.37 5.23 5.23 0 00-1.91 1.14 5.63 5.63 0 00-1.32 2 7.25 7.25 0 00-.5 2.84 4.41 4.41 0 001.17 2.94 6.42 6.42 0 003.07 1.93l6.68 2.07a12.19 12.19 0 015.2 2.8 10.1 10.1 0 012.75 4.61zM128.89 140.52a3.77 3.77 0 01-1.14 2.77 3.71 3.71 0 01-2.72 1.14 3.88 3.88 0 01-3.91-3.91 3.71 3.71 0 011.13-2.72 3.77 3.77 0 012.77-1.13 3.88 3.88 0 013.85 3.85z"
    />
    <path
      className="icons_attributes_15_05_2019_Team_Player_svg__cls-2"
      d="M175.9 192.5v.5c-.06 8.32-.18 13.86-.4 14.5-1 3-109 8-113 2s-1-115-1-115l-35-1-7-33s15-8 41-16 32-11 32-11 26 13 52 1c0 0 63 19 72 26 0 0-4.17 33-7 33-5 0-34 1-34 1s.39 42.6.44 75.5"
    />
    <path
      className="icons_attributes_15_05_2019_Team_Player_svg__cls-3"
      d="M61.5 94.5s11-31-1-50M175.5 94.5s-8-26-1-49"
    />
    <path
      className="icons_attributes_15_05_2019_Team_Player_svg__cls-2"
      d="M92.5 34.5c.89 1.21 27.11 40.45 52 0"
    />
    <path
      className="icons_attributes_15_05_2019_Team_Player_svg__cls-4"
      d="M86.75 36.5s.48 1 1.43 2.63"
    />
    <path
      d="M91.5 44.1c5 6.7 14.08 15.4 27 15.4 16.26 0 25.2-9.82 29.07-18.34"
      strokeDasharray="5.97 5.97"
      strokeWidth={2}
      fill="none"
      stroke={color}
      strokeMiterlimit={10}
    />
    <path
      className="icons_attributes_15_05_2019_Team_Player_svg__cls-4"
      d="M148.68 38.38a26.8 26.8 0 00.82-2.88"
    />
    <path
      className="icons_attributes_15_05_2019_Team_Player_svg__cls-2"
      d="M97.75 41.75s23.75 9.75 42.75-1.25"
    />
  </svg>
);

IconTeamPlayer.defaultProps = { ...defaultProps };
IconTeamPlayer.propTypes = { ...iconPropTypes };
